import React from 'react';
import {getServerTexts} from '../texts';
import {ReportsDialog} from './ReportsDialog';

export async function renderReportsDialog(root, data) {
    const reportsDialogRef: React.RefObject<typeof ReportsDialog> = React.createRef();
    await getServerTexts();
    const props = data?.Procedure?.length && data.Procedure[0];

    root.render(
        <ReportsDialog
            key={data.selector}
            ref={reportsDialogRef}
            {...props}
            elementId={data.selector}
            ename={data.ename}
            etype={data.etype}
            zoomValue={data.zoomValue}
        />
    );
    return reportsDialogRef;
}
